module.exports = __webpack_public_path__ + "static/media/car-vector.927c51a3.png";